import { render, staticRenderFns } from "./PaginaAsignacionBoletasMuni.vue?vue&type=template&id=4b98f7ce"
import script from "./PaginaAsignacionBoletasMuni.vue?vue&type=script&lang=js"
export * from "./PaginaAsignacionBoletasMuni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports